import React, { useState } from "react";
import { Eye, Clock, Image } from "lucide-react";
import { Settings } from "lucide-react";
import PopUp from "../components/PopUp";
import { Check } from "lucide-react";
import "../styling/DevCardsLayout.css";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";




export default function CardsLayout() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSlides, setLightboxSlides] = useState([]);

  const handleViewGallery = (project) => {
    setLightboxSlides(project);
    setLightboxOpen(true);
  };

  const [FeaturesPopUpOpen, setFeaturesPopUpOpen] = useState(false);
  const [FeaturesPopUpContent, setFeaturesPopUpContent] = useState(null);
  const handleFeaturesValue = (features) => {
    const contentElements = features.map((feature, idx) => (
      <div
        key={idx}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "8px",
          lineHeight: "1.4",
        }}
      >
         <span style={{ color: 'red', marginRight: '10px' }}>✔</span>
        <span style={{ display: "inline-block" }}>{feature}</span>
      </div>
    ));
    setFeaturesPopUpContent(contentElements);
    setFeaturesPopUpOpen(true);
  };

  const projects = [
    {
      title: "Recycling App",
      age: "2024/Present (Still Under Maintenance)",
      tag: "Flutter",
      description:
        "A mobile application providing a comprehensive solution to the problem of waste accumulation .",
      preview: "Live Demo",

      Features: [
        "Flutter-based application (cross-platform) with a Laravel backend and REST APIs services",
        "State management using Riverpod combined with MVVM architecture ",
        "Role-based Authentication (JWT tokens). Assigning roles such as Users or Admins for controlling access & resources",
        "Waste Management Transactions: The application allows users to track their transaction status",
        "User Wallet: Users are provided with wallets to manage the revenue collected from transactions",
        "Notification System: Keeping users informed about important announcements",
        "Administrative Panel: Admins have access to a dedicated panel for managing users, roles, announcements, transactions, revenue exchanges, etc.",
      ],

      image: "https://i.imghippo.com/files/AgO7748AWM.webp",
      images: 
[
  { src: "https://i.imghippo.com/files/hrD1422NY.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/AgO7748AWM.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/xhA4455XR.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/ghbv4094YU.webp", width: 1600, height: 1200 }
]

      ,
    },
    {
      title: " Slack bots (Zapier)",
      age: "2024",
      github: "Github Link",
      tag: "Python",
      description: "Slack notification integration",
      preview: "Live Demo",
      image: "https://i.imghippo.com/files/yIXX3899hsI.webp",
      Features: [
        "Maintained and managed Slack bots for various automation tasks and notifications.",
        "Integrated Calendly with Slack using Python scripts and APIs to streamline scheduling and notifications.",
        "Monitored and troubleshot for bugs.",
      ],

      images: [
  { src: "https://i.imghippo.com/files/yIXX3899hsI.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/Hzhi1114oho.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/UO2002CA.webp", width: 1600, height: 1200 }
]
,
    },
    {
      title: "Personal Blog",
      age: "2024",
      github: "Github Link",
      tag: "React",
      description: "A personal blog website to share and manage blog posts.",
      preview: "Live Demo",
      image: "https://i.imghippo.com/files/EVA4079lk.webp",
      Features: [
        "Built REST APIs for users and admins using Express.js and MongoDB with JWT authorization and role-based access control (admin and users)",
      "Designed a responsive modern UI using React MUI",
        "Enhanced data loading with pagination, optimized filtering functions, and Excel export capability",
        "Users can create blogs with content, tags, categories, images, and control visibility (public/private)",
        "Admins have full access to manage all blogs",
        
      ],

      images: [
    { src: "https://i.imghippo.com/files/ojeA8214IqQ.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/jti4930VZg.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/EVA4079lk.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/TR3900zf.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/zuU4597HlA.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/prSN4210UA.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/TMy6344eYg.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/aQQ1467ESc.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/pyY1373BQs.webp", width: 1600, height: 1200 }
]
,
    },
    {
      title: "IFAC",
      age: "2024",
      Features: [
        "Designed a responsive modern UI using React MUI",
        "Backend built with Node.js (Express) and MongoDB ",
        "Admins can manage events and news",
        "Integrated and customized React Big Calendar for event management",
        "Users can view news and events displayed through React Big Calendar",
      ],
      github: "Github Link",
      tag: "React",
      description:
        "Informative site with event management and an integrated calendar.",
      preview: "Live Demo",
      image: "https://i.imghippo.com/files/P2977ls.webp",
      images: [
  
  { src: "https://i.imghippo.com/files/P2977ls.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/cvre2072W.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/btNu8117LQc.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/XTn8565Qr.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/enp3171axc.webp", width: 1600, height: 1200 },
  { src: "https://i.imghippo.com/files/IXGY3775LsM.webp", width: 1600, height: 1200 }


      ],
    },
    ,
    {
      title: "Chess",
      age: "2023",
      github: "Github Link",
      tag: "Python",
      description: "A voice-controlled chess game built with Python",
      preview: "Live Demo",
      Features: [
        "Developed voice-command chess game using Python(voice recognition library)",
        "Customized chess engine",
      ],
      image: "https://i.imghippo.com/files/eGE7394loQ.webp",
      images: [
           { src: "https://i.imghippo.com/files/eGE7394loQ.webp",width: 1600, height: 1200 },
            { src: "https://i.imghippo.com/files/H6167PuI.webp",width: 1600, height: 1200 },
      ],
    },
    ,
    {
      title: "Insurance",
      age: "2023",
      github: "Github Link",  tag: "Php",
      description: "CMS dashboard designed for health insurance companies to facilitate their work",
      Features: [
  "Designed a responsive modern UI using Bootstrap.",
  "Used pure PHP as the backend and MySQL as the database.",
  "Blocked website access for users outside Lebanon using IP_API.",
  "Admin can add users (patient profiles), track website views, view incoming messages, and manage appointments.",
  "Users can book appointments through the Contact Us page.",
  "Insurance taxes are generated dynamically when users are added; admins can mark taxes as received.",
  "Users can log in to view their progress and upcoming taxes."
],
      preview: "Live Demo",
      image: "https://i.imghippo.com/files/Jos4556SY.webp",
      images: [
        { src: "https://i.imghippo.com/files/Jos4556SY.webp",width: 1600, height: 1200 },
         { src: "https://i.imghippo.com/files/VRWm7769rmg.webp",width: 1600, height: 1200 },
          { src: "https://i.imghippo.com/files/mou9658pcg.webp",width: 1600, height: 1200 },
           { src: "https://i.imghippo.com/files/nQW2733IvU.webp",width: 1600, height: 1200 },
            { src: "https://i.imghippo.com/files/ECuq7705MT.webp",width: 1600, height: 1200 },
             { src: "https://i.imghippo.com/files/Xje6270Sd.webp",width: 1600, height: 1200 },
              { src: "https://i.imghippo.com/files/wBp4132xM.webp",width: 1600, height: 1200 },
               { src: "https://i.imghippo.com/files/ghAH4274CU.webp",width: 1600, height: 1200 },
                { src: "https://i.imghippo.com/files/RF7054dbw.webp",width: 1600, height: 1200 },
                 { src: "https://i.imghippo.com/files/UTY2743eI.webp",width: 1600, height: 1200 },
                  { src: "https://i.imghippo.com/files/hmRa8666ItQ.webp",width: 1600, height: 1200 },
                   { src: "https://i.imghippo.com/files/FvjR7391o.webp",width: 1600, height: 1200 },
                    { src: "https://i.imghippo.com/files/mdTt6421DI.webp",width: 1600, height: 1200 },
      ],
    },
    {
      title: "Gaming Site",
      age: "2022",
      github: "Github Link",
      tag: "Html",
      description:
        "Gaming website to showcase trending games across all genres.",
      preview: "Live Demo",
      Features: ["Build Website using Pure HTML/CSS/JS", "Responsive UI"],

      image: "https://i.imghippo.com/files/wHaB7878Ok.webp",
      images: [
  { src: "https://i.imghippo.com/files/wHaB7878Ok.webp",width: 1600, height: 1200 },
   { src: "https://i.imghippo.com/files/AEb5413Vc.webp",width: 1600, height: 1200 },
    { src: "https://i.imghippo.com/files/sic8271XDY.webp",width: 1600, height: 1200 },
     { src: "https://i.imghippo.com/files/Iynu4140SXc.webp",width: 1600, height: 1200 },
      { src: "https://i.imghippo.com/files/rq5522QUc.webp",width: 1600, height: 1200 },
       { src: "https://i.imghippo.com/files/mVp3283SKY.webp",width: 1600, height: 1200 },

]

    },
  ];

  return (
    <>
      <div className="project-grid">
        {projects.map((project, index) => (
          <div className="card" key={index}>
            <div className="card-top">
              <div className="text-section">
                <h2 className="project-title">{project.title}</h2>
                <span className="badge">{project.tag}</span>
                <div className="info-row">
                  <Clock className="icon" /> {project.age}
                </div>
              </div>
              <img src={project.image} alt="preview" className="preview-img" />
            </div>
            <p className="description">{project.description}</p>
            <div className="links">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handleFeaturesValue(project.Features);
                }}
                href="#"
              >
                <Settings className="icon" /> Features
              </a>

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewGallery(project.images);
                }}
              >
                <Image className="icon" /> View Project Set
              </a>
              <a href="#">
                <Eye className="icon" /> {project.preview}
              </a>
            </div>
          </div>
        ))}
      </div>
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        plugins={[Zoom]}
        slides={lightboxSlides}
      />

      <PopUp
        visibility={FeaturesPopUpOpen}
        content={FeaturesPopUpContent}
        onClose={() => setFeaturesPopUpOpen(false)}
      />
    </>
  );
}
